module.exports = __webpack_public_path__ + "static/media/landscape_decore.f039a44a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/landscape_decore.svg
// module id = 1436
// module chunks = 0